import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import pages from '../../../routes/pages';
import { useDispatch, useSelector } from 'react-redux';
import { getPanier } from '../../../store/selectors/panier/panier.selectors';
import usePublicShop from '../../../hooks/usePublicShop';
import { PanierView } from './Panier.view';
import { isPanierPage } from '../../../types/panier/panier.def';
import {
  removeLine,
  updateProductQuantity as updateProductQuantityAction
} from '../../../store/actions/panier.actions';
import { clearCart } from '../../../store/actions/panier.actions';
import { getGoToPage } from '../../../helpers/page/goToPage';
import useGoToPage from '../../../hooks/useGoToPage';
import { isCommandePage } from '../../../helpers/commande/isCommandePage';
import { getChallengeStatus } from '../../../store/selectors/user/user.selectors';
import { FeatureContainer } from '../../molecules/Containers/FeatureContainer';
import useStyle from './panier.style';

export const Panier = () => {
  const panier = useSelector(getPanier);
  const { status } = useSelector(getChallengeStatus);
  const location = useLocation();
  const currentLocation = location.pathname;
  const history = useHistory();
  const dispatch = useDispatch();
  const goToReporting = useGoToPage(pages.PRODUCTS_PAGE.path);
  const classes = useStyle();

  const { isPublicShop, shopId, classeId } = usePublicShop();

  const updateProductQuantity = async (productId: string, quantity: number) => {
    dispatch(
      updateProductQuantityAction({
        productId: productId,
        quantity: quantity
      })
    );
  };

  const links = isPublicShop
    ? {
        onClickCommander: getGoToPage(history)(
          pages.PUBLIC_SHOP_COMMANDE.path,
          shopId,
          classeId
        ),
        onClickModifier: getGoToPage(history)(
          pages.PUBLIC_SHOP_HOME.path,
          shopId,
          classeId
        ),
        onClickViewMore: getGoToPage<{ idProduit: string }>(history)(
          pages.PUBLIC_SHOP__SINGLE_PRODUCT.path,
          shopId,
          classeId
        )
      }
    : {
        onClickCommander: getGoToPage(history)(pages.COMMANDE_PAGE.path),
        onClickModifier: getGoToPage(history)(pages.PANIER_PAGE.path),
        onClickViewMore: getGoToPage<{ idProduit: string }>(history)(
          pages.PRODUCT_SINGLE_PAGE.path
        )
      };

  const isCmdPage = isCommandePage(currentLocation);

  const cartVariant = isCmdPage
    ? 'recap'
    : isPanierPage(currentLocation)
    ? 'panier'
    : 'reporting';

  const onClickTrash = (lineToRemove: number, totalLine: number) =>
    dispatch(removeLine({ lineToRemove, totalLine }));

  const removeAll = () => dispatch(clearCart);

  return (
    <>
      {status === 'notStarted' && (
        <div className={cartVariant !== 'reporting' && classes.infoBlock}>
          <FeatureContainer>
            <div className={classes.textContainer}>
              <h2>
                Le challenge n'a pas encore commencé. Tu ne peux pas saisir de
                vente pour le moment.{' '}
                <span role="img" aria-label="emojis_déçu">
                  😕
                </span>
              </h2>
            </div>
          </FeatureContainer>
        </div>
      )}
      {status === 'ended' && (
        <div className={cartVariant !== 'reporting' && classes.infoBlock}>
          <FeatureContainer>
            <div className={classes.textContainer}>
              <h2>
                Le challenge est terminé. Tu ne peux plus saisir de vente.{' '}
                <span role="img" aria-label="emojis_déçu">
                  😕
                </span>
              </h2>
            </div>
          </FeatureContainer>
        </div>
      )}
      {status === 'available' && (
        <PanierView
          panier={panier}
          cartVariant={cartVariant}
          isPanierPage={isPanierPage(currentLocation)}
          onClickCommander={links.onClickCommander}
          onClickModifier={links.onClickModifier}
          onClickViewMore={links.onClickViewMore}
          onClickTrash={onClickTrash}
          removeAll={removeAll}
          isPublicShop={isPublicShop}
          goToReporting={goToReporting}
          updateQuantity={updateProductQuantity}
        />
      )}
    </>
  );
};
